import Switch from 'react-bootstrap-switch';

import 'react-bootstrap-switch/dist/css/bootstrap3/react-bootstrap-switch.css';

export default Switch;
